export default "__VITE_ASSET__De6kDsbO__"